var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-member')
}
var staticRenderFns = []

export { render, staticRenderFns }